import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Mount the React app to the DOM element with id "survey-app"
document.addEventListener('DOMContentLoaded', () => {
    const surveyAppElement = document.getElementById('survey-app');

    if (surveyAppElement) {
        const root = createRoot(surveyAppElement);
        root.render(<App />);
    } else {
        console.warn('Element with id "survey-app" not found');
    }
});
